const fetchRestAPI = (
  resource: string,
  method: string,
  body: any = null,
  headers: any = {
    "Content-Type": "application/json", // Make sure to set appropriate headers
  },
) => {
  const options: RequestInit = {
    headers,
    method,
    credentials: "include",
  };

  if (body instanceof FormData) {
    delete options.headers;
  }

  if (body && method !== "GET" && method !== "HEAD") {
    options.body = body instanceof FormData ? body : JSON.stringify(body);
  }

  return fetch(`/api/${resource}`, options);
};

export const common = {
  fetchRestAPI,
};
